<ng-content select=".before"></ng-content>
<span class="button__text"><ng-content></ng-content></span>
<ng-content select=".after"></ng-content>